import React from "react";

import productService from "../services/productService";

import { showProcess, hideProcess, getFileServer } from "../utils/util";
import { Galleria } from "primereact/galleria";
import Banner001 from "../img/Banner001.png";
import { useParams } from "react-router-dom";

function withParams() {
    return (props) => <Category {...props} params={useParams()} />;
}

class Category extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            products: [],
            fileServer: getFileServer(),
            windowWidth: window.innerWidth,
        };
    }

    async componentDidMount() {
        try {
            await showProcess();

            const response = await productService.getByStatusAndTypeAndCategory(
                "ACTIVE",
                "VIRTUAL",
                this.props.params.category
            );

            if (response.status === 200) {
                this.setState({ products: response.data.filter((p) => !p.child) });
            } else {
                alert("ERRO AO CARREGAR PAGINA");
            }
        } catch (err) {
            if (err.response) {
                console.log("status", err.response.status);
                console.log("headers", err.response.headers);
                console.log("data", err.response.data); // <- aqui normalmente vem a dica do que faltou
            } else {
                console.log("message", err.message);
            }
        }

        hideProcess();

        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth });
    };

    banners = [
        {
            url: Banner001,
        },
        {
            url: Banner001,
        },
        {
            url: Banner001,
        },
    ];

    listPrices(product) {
        if (product.childProducts !== undefined) {
            var prices = "";
            product.childProducts.forEach((p) => (prices += "R$ " + p.amount + " | "));

            prices = prices.substring(0, prices.length - 3);
            return prices;
        } else {
            return "R$ " + product.amount;
        }
    }

    render() {
        const { windowWidth } = this.state;
        const isMobile = windowWidth <= 768;
        return (
            <>
                <div
                    style={{width: "100%", 
                             backgroundColor: "var(--unnamed-color-411172)", 
                             color: "#ffffff", 
                             padding: "30px", 
                             marginBottom: "30px", 
                             borderRadius: "0px", 
                             fontSize: "53px", 
                             fontWeight: "600",
                             textAlign: "left"
                    }}
                    className="header-category-mobile"
                >
                    {this.props.params.category.toUpperCase()}
                </div>

                <section
                    className="app-cards-container"
                    style={{
                        padding: "10px",
                        width: "100%",      
                        boxSizing: "border-box",
                        backgroundColor: "#F3F3F3"
                    }}
                >
                    <div
                        className="app-cards-products"
                        style={{
                            display: "flex",
                            flexWrap: "wrap",
                            justifyContent: "space-between",
                            gap: "20px",
                            width: "100%",
                        }}
                    >
                        {this.state.products
                            .filter((p) =>
                                p.displayName
                                    .toUpperCase()
                                    .includes(this.props.search.toUpperCase())
                            )
                            .splice(0, 20)
                            .map((p) => (
                                <div
                                    className="app-card-product"
                                    onClick={() => (window.location.href = "/product/" + p.id)}
                                    style={{
                                        backgroundColor: "#fff",
                                        border: "1px solid #ddd",
                                        borderRadius: "10px",
                                        boxShadow: "0px 4px 8px rgba(0,0,0,0.1)",
                                        cursor: "pointer",
                                        padding: "25px 0px 20px",
                                        width: window.innerWidth < 768 ? "90%" : "300px", // ← aqui o ajuste
                                        minWidth: "150px",
                                        textAlign: "center",
                                        transition: "transform 0.2s ease-in-out",
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "space-between",
                                        height: "auto",
                                        margin: window.innerWidth < 768 ? "10px auto" : "0", // centraliza no mobile
                                    }}
                                    onMouseOver={(e) =>
                                        (e.currentTarget.style.transform = "scale(1.05)")
                                    }
                                    onMouseOut={(e) =>
                                        (e.currentTarget.style.transform = "scale(1)")
                                    }
                                >
                                    <img
                                        src={`${this.state.fileServer}/cards/${p.id}.png`}
                                        alt={p.displayName}
                                        style={{
                                            width: "100%",
                                            height: "170px",
                                            objectFit: "contain",
                                            borderRadius: "10px",
                                            marginBottom: "20px",
                                        }}
                                    />
                                    <span
                                        className="app-card-product-name"
                                        style={{
                                            display: "block",
                                            fontSize: "20px",
                                            fontWeight: "500",
                                            color: "#000141",
                                            minHeight: "40px",
                                            lineHeight: "1.2em",
                                            marginBottom: "5px",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {p.displayName}
                                    </span>
                                    <p
                                        className="app-card-product-price"
                                        style={{
                                            color: "#707070",
                                            fontSize: "15px",
                                            margin: "10px 0",
                                            flexGrow: 0,
                                        }}
                                    >
                                        {this.listPrices(p)}
                                    </p>
                                    
                                    <div style={{width:"100%", textAlign: "center"}}>
                                        <button
                                            style={{
                                                backgroundColor: "#411172",
                                                color: "#fff",
                                                border: "none",
                                                borderRadius: "50px",
                                                padding: "15px 25px",
                                                fontSize: "15px",
                                                cursor: "pointer",
                                                width: "fit-content",
                                                fontWeight: "500",
                                                marginTop: "auto",
                                            }}
                                        >
                                            Comprar
                                        </button>
                                    </div>
                                    
                                </div>
                            ))}
                    </div>
                </section>
            </>
        );
    }
}

export default withParams();
